import { ReactNode } from 'react';

import ErrorMessageStyled from './error-message.style';

export type ErrorMessageProps = {
  className?: string;
  message?: string | null;
  centreText?: boolean;
  marginBottom?: number;
  marginTop?: number;
  children?: ReactNode;
};

const ErrorMessage = ({
  className,
  message,
  centreText,
  marginBottom,
  marginTop,
  children,
}: ErrorMessageProps) => {
  return (
    <ErrorMessageStyled
      className={className}
      centreText={centreText}
      marginBottom={marginBottom}
      marginTop={marginTop}
      role="alert"
      data-selector="server-error"
    >
      {message}
      {children}
    </ErrorMessageStyled>
  );
};

export default ErrorMessage;
